import { render, staticRenderFns } from "./AetherpayDeposit.vue?vue&type=template&id=33283068&"
import script from "./AetherpayDeposit.vue?vue&type=script&lang=js&"
export * from "./AetherpayDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports